export const ROUTE_PATH = '/dashboard';
